import JQueryView, { on } from '../../../../../../common/views/jqueryView';
import $ from 'jquery';

export default class FileUploadView extends JQueryView {
  constructor() {
    super('.simple_form');

    this.render();
  }

  @on({ event: 'input', selector: '#investor_specific_application_assets' })
  onInputAssets() {
    this.render();
  }

  @on({
    event: 'input',
    selector: '#investor_specific_application_liabilities',
  })
  onInputLiabilities() {
    this.render();
  }

  @on({
    event: 'change',
    selector:
      '#investor_specific_application_check_box_income_paper_work_company_name_vary_reason',
  })
  onChangeCheckBoxIncomePaperReason() {
    this.render();
  }

  @on({
    event: 'change',
    selector:
      '#investor_specific_application_income_paper_work_company_name_vary_reason',
  })
  onChangeIncomePaperReason() {
    this.render();
  }

  @on({
    event: 'change',
    selector:
      '#investor_specific_application_check_box_specific_knowledge_paper_work_company_name_vary_reason',
  })
  onChangeCheckBoxSpecificKnowledgeReason() {
    this.render();
  }

  @on({
    event: 'change',
    selector:
      '#investor_specific_application_specific_knowledge_paper_work_company_name_vary_reason',
  })
  onChangeSpecificKnowledgeReason() {
    this.render();
  }

  @on({
    event: 'change',
    selector: '#investor_specific_application_income_papers',
  })
  onChangeIncomePapers() {
    this.render();
  }

  @on({
    event: 'change',
    selector: '#investor_specific_application_specific_knowledge_papers',
  })
  onChangeSpecificKnowledgePapers() {
    this.render();
  }

  @on({
    event: 'change',
    selector:
      '#investor_specific_application_investible_financial_asset_papers',
  })
  onChangeInvestibleFinancialAssetPapers() {
    this.render();
  }

  canSubmit() {
    const pattern = $('#investor_specific_application_pattern').val();

    switch (pattern) {
      case 'pattern_1':
      case 'pattern_2':
      case 'pattern_4':
        return this.canSubmitPatternA();
      case 'pattern_3':
        return this.canSubmitPatternB();
      case 'pattern_5':
      case 'pattern_6':
      case 'pattern_8':
        return this.canSubmitPatternC();
      case 'pattern_7':
        return this.canSubmitPatternD();
      case 'pattern_9':
      case 'pattern_10':
      case 'pattern_12':
        return this.canSubmitPatternE();
      case 'pattern_11':
        return this.canSubmitPatternF();
      case 'pattern_13':
        return this.canSubmitPatternG();
      case 'pattern_14':
      case 'pattern_16':
      case 'pattern_17':
        return this.canSubmitPatternH();
      case 'pattern_15':
      case 'pattern_18':
        return this.canSubmitPatternI();
      default:
        break;
    }
  }

  canSubmitPatternA() {
    return (
      this.checkIncomePapers() &&
      this.checkSpecificKnowledgePapers() &&
      this.checkIncomePaperReason() &&
      this.checkSpecificKnowledgeReason()
    );
  }

  canSubmitPatternB() {
    return (
      this.checkIncomePapers() &&
      this.checkSpecificKnowledgePapers() &&
      this.checkIncomePaperReason()
    );
  }

  canSubmitPatternC() {
    return (
      this.checkInvestibleFinancialAssetPapers() &&
      this.checkSpecificKnowledgePapers() &&
      this.checkNetAssets() &&
      this.checkSpecificKnowledgeReason()
    );
  }

  canSubmitPatternD() {
    return (
      this.checkInvestibleFinancialAssetPapers() &&
      this.checkSpecificKnowledgePapers() &&
      this.checkNetAssets()
    );
  }

  canSubmitPatternE() {
    return (
      this.checkInvestibleFinancialAssetPapers() &&
      this.checkSpecificKnowledgePapers() &&
      this.checkSpecificKnowledgeReason()
    );
  }

  canSubmitPatternF() {
    return (
      this.checkInvestibleFinancialAssetPapers() &&
      this.checkSpecificKnowledgePapers()
    );
  }

  canSubmitPatternG() {
    return this.checkIncomePapers() && this.checkIncomePaperReason();
  }

  canSubmitPatternH() {
    return this.checkInvestibleFinancialAssetPapers() && this.checkNetAssets();
  }

  canSubmitPatternI() {
    return this.checkInvestibleFinancialAssetPapers();
  }

  checkIncomePapers() {
    const incomePapers = $('#investor_specific_application_income_papers');

    return 0 < (incomePapers.val()?.toString() ?? '').length;
  }

  checkSpecificKnowledgePapers() {
    const specificKnowledgePapers = $(
      '#investor_specific_application_specific_knowledge_papers',
    );

    return 0 < (specificKnowledgePapers.val()?.toString() ?? '').length;
  }

  checkInvestibleFinancialAssetPapers() {
    const investibleFinancialAssetPapers = $(
      '#investor_specific_application_investible_financial_asset_papers',
    );

    return 0 < (investibleFinancialAssetPapers.val()?.toString() ?? '').length;
  }

  checkIncomePaperReason() {
    const checkBoxIncomePaperReason = $(
      '#investor_specific_application_check_box_income_paper_work_company_name_vary_reason',
    );
    const incomePaperReasonLength = (
      $(
        '#investor_specific_application_income_paper_work_company_name_vary_reason',
      )
        .val()
        ?.toString() ?? ''
    ).length;

    if (
      checkBoxIncomePaperReason.prop('checked') &&
      incomePaperReasonLength === 0
    ) {
      return false;
    }

    return true;
  }

  checkSpecificKnowledgeReason() {
    const checkBoxSpecificKnowledgeReason = $(
      '#investor_specific_application_check_box_specific_knowledge_paper_work_company_name_vary_reason',
    );
    const specificKnowledgeReasonLength = (
      $(
        '#investor_specific_application_specific_knowledge_paper_work_company_name_vary_reason',
      )
        .val()
        ?.toString() ?? ''
    ).length;

    if (
      checkBoxSpecificKnowledgeReason.prop('checked') &&
      specificKnowledgeReasonLength === 0
    ) {
      return false;
    }

    return true;
  }

  checkNetAssets() {
    const assets =
      $('#investor_specific_application_assets').val()?.toString() ?? '';
    const liabilities =
      $('#investor_specific_application_liabilities').val()?.toString() ?? '';
    const pattern = $('#investor_specific_application_pattern').val();
    let minNetAssets = 0;

    switch (pattern) {
      case 'pattern_5':
      case 'pattern_6':
      case 'pattern_7':
      case 'pattern_8':
        minNetAssets = 100;
        break;
      case 'pattern_14':
      case 'pattern_16':
        minNetAssets = 300;
        break;
      case 'pattern_17':
        minNetAssets = 500;
        break;
      default:
        break;
    }

    return (
      0 < assets.length &&
      0 <= parseInt(assets) &&
      0 < liabilities.length &&
      0 <= parseInt(liabilities) &&
      minNetAssets <= parseInt(assets) - parseInt(liabilities)
    );
  }

  render() {
    const specificKnowledgeReason = $(
      '#investor_specific_application_check_box_specific_knowledge_paper_work_company_name_vary_reason',
    )[0];
    const incomePaperReason = $(
      '#investor_specific_application_check_box_income_paper_work_company_name_vary_reason',
    )[0];
    const assets =
      $('#investor_specific_application_assets').val()?.toString() ?? '';
    const liabilities =
      $('#investor_specific_application_liabilities').val()?.toString() ?? '';

    if (
      specificKnowledgeReason &&
      (specificKnowledgeReason as HTMLInputElement).checked
    ) {
      $('.specific-knowledge-paper-work-company-name-vary-reason').show();
    } else {
      $(
        '#investor_specific_application_specific_knowledge_paper_work_company_name_vary_reason',
      ).val('');
      $('.specific-knowledge-paper-work-company-name-vary-reason').hide();
    }

    if (incomePaperReason && (incomePaperReason as HTMLInputElement).checked) {
      $('.income-paper-work-company-name-vary-reason').show();
    } else {
      $(
        '#investor_specific_application_income_paper_work_company_name_vary_reason',
      ).val('');
      $('.income-paper-work-company-name-vary-reason').hide();
    }

    if (assets.length > 0 && liabilities.length > 0) {
      $('#investor_specific_application_net_assets').val(
        parseInt(assets) - parseInt(liabilities),
      );
    }

    if (this.canSubmit()) {
      $('#btn-submit').prop('disabled', false);
    } else {
      $('#btn-submit').prop('disabled', true);
    }
  }
}
